var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.sectionClasses,attrs:{"role":"contentinfo"}},[_c('div',{staticClass:"container",style:({ maxWidth: _vm.maxWidth })},[_vm._t("header"),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }